// extracted by mini-css-extract-plugin
export default {"locked":"HzTl0","fixed":"_2sEBE","stretch":"_1Fnuv"};